import { SortOptionsEnum } from 'common/features/VirtualList/VirtualList.config';
import { SortState } from './sort.types';

export const getDefaultSortOption = (defaultSortOption: SortOptionsEnum): SortState => ({
  currentSort: defaultSortOption,
});
